import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
    selector: "wbo-edit-page-side-panel",
    templateUrl: "./edit-page-side-panel.component.html",
    styleUrls: ["edit-page-side-panel.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditPageSidePanel {

}
